// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumbs_container__refpw","breadcrumb":"Breadcrumbs_breadcrumb__7XuFO","item":"Breadcrumbs_item__s9H_G"};